// import React from "react";
// import "./InvoiceIRN.scss";
// import { Button, Input, Modal, Tag } from "antd";
// import { useState } from "react";
// import { useRecoilState } from "recoil";
// import {
//   gst2ADataState,
//   gst2BDataState,
//   irndata,
//   roleInfo,
//   userInfo,
//   vendorDetailsDisplay,
//   workspaceInfo,
// } from "app/config/States/users";

// //Import the endpoints
// import { API_ENDPOINT_VENDOR_VALIDATE } from "../../vendorfollowup.constants";
// import { BeatLoader } from "react-spinners";
// import CircleIcon from "@mui/icons-material/Circle";
// import { EyeOutlined, CheckCircleFilled ,CloseCircleFilled} from "@ant-design/icons";
// import { ReactComponent as ArrowIcon } from "../../arrow.svg";
// import EmailModal from "../EmailModel/EmailModel";
// import Typography from "app/shared/Typography";
// import { Select } from "antd";
// import { DownOutlined } from "@ant-design/icons";

// const InvoiceIRN = () => {
//   const [activeTab, setActiveTab] = useState("invoice");
//   const { Option } = Select;//new
//   const [showVendorDetails, setShowVendorDetails] =
//     useRecoilState(vendorDetailsDisplay);
//   const [irnloading, setIrnLoading] = useState(false);
//   const [is2A, setIs2A] = useState(true);
//   const [invoiceData, setInvoiceData] = useRecoilState(irndata);
//   const [stateShortForm, setStateShortForm] = useState("");
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const closeEmailModal = () => setIsEmailModalOpen(false);
//   const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
//   const [formData, setFormData] = useState({
//     vendorGSTIN: "",
//     financialYear: "",
//     invoiceType: "",
//     invoiceNumber: "",
//     irnNumber: "",
//   });
//   const handleRequestClick = () => {
//     setIsEmailModalOpen(true);
//   };

//   // const handleChange = (e) => {
//   //   const { name, value } = e.target;
//   //   setFormData({ ...formData, [name]: value });
//   // };


//   const handleChange = (value, option) => {
//     if (option && option.name) {
//       // Handling Ant Design Select
//       setFormData((prevData) => ({
//         ...prevData,
//         [option.name]: value, // Update based on the select field name
//       }));
//     } else if (value?.target) {
//       // Handling regular input field
//       const { name, value: inputValue } = value.target;
//       setFormData((prevData) => ({
//         ...prevData,
//         [name]: inputValue,
//       }));
//     }
//   };

//   const handleSelectChange = (name, value) => {
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };




//   const stateShortFormMapping = {
//     "01": "JK", // Jammu & Kashmir
//     "02": "HP", // Himachal Pradesh
//     "03": "PB", // Punjab
//     "04": "CH", // Chandigarh
//     "05": "UK", // Uttarakhand
//     "06": "HR", // Haryana
//     "07": "DL", // Delhi
//     "08": "RJ", // Rajasthan
//     "09": "UP", // Uttar Pradesh
//     10: "BR", // Bihar
//     11: "SK", // Sikkim
//     12: "AR", // Arunachal Pradesh
//     13: "NL", // Nagaland
//     14: "MN", // Manipur
//     15: "MZ", // Mizoram
//     16: "TR", // Tripura
//     17: "ML", // Meghalaya
//     18: "AS", // Assam
//     19: "WB", // West Bengal
//     20: "JH", // Jharkhand
//     21: "OD", // Odisha
//     22: "CG", // Chhattisgarh
//     23: "MP", // Madhya Pradesh
//     24: "GJ", // Gujarat
//     25: "DD", // Daman & Diu
//     26: "DN", // Dadra & Nagar Haveli
//     27: "MH", // Maharashtra
//     28: "AP", // Andhra Pradesh
//     29: "KA", // Karnataka
//     30: "GA", // Goa
//     31: "LD", // Lakshadweep
//     32: "KL", // Kerala
//     33: "TN", // Tamil Nadu
//     34: "PY", // Puducherry
//     35: "AN", // Andaman & Nicobar Islands
//     36: "TG", // Telangana
//     37: "AP", // Andhra Pradesh (New)
//   };
//   const mapInvoiceStatus = (status) => {
//     return status === "Invoice Received" ? "Received" : "Not Received";
//   };

//   const mapInvoiceType = (type) => {
//     switch (type) {
//       case "INV":
//         return "E-tax invoice";
//       case "CRN":
//         return "Credit note";
//       case "DBN":
//         return "Debit note";
//       default:
//         return type; // Return the original type if no mapping is found
//     }
//   };



//   const handleValidate = async () => {
//     if (
//       (activeTab === "invoice" &&
//         (!formData.vendorGSTIN ||
//           !formData.financialYear ||
//           !formData.invoiceType ||
//           !formData.invoiceNumber)) ||
//       (activeTab === "irn" && !formData.irnNumber)
//     ) {
//       alert("Please fill all the required fields.");
//       return;
//     }

//     if (
//       activeTab === "irn" &&
//       (!formData.irnNumber || formData.irnNumber.length !== 64)
//     ) {
//       alert("IRN Number must be exactly 64 characters.");
//       return;
//     }

//     setIrnLoading(true);
//     try {
//       const currentWorkspace = localStorage.getItem("currentWorkspace");
//       // const payload = activeTab === "irn" ? { irnNumber: formData.irnNumber } : formData;
//       const collection = 'vendor_tally'
//       const payload =
//         activeTab === "irn"
//           ? {
//             irnNumber: formData.irnNumber,
//             collection: collection,
//             db: "gstservice",
//             currentWorkspace,
//           }
//           : {
//             ...formData,
//             collection: collection,
//             db: "gstservice",
//             currentWorkspace,
//           };
//       const response = await fetch(
//         API_ENDPOINT_VENDOR_VALIDATE,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(payload),
//         }
//       );


//       const data = await response.json();

//       setInvoiceData({
//         inum: data.data?.Doc_data?.inum,
//         date: data.data?.Doc_data?.dt,
//         eligibleStatus: data.data?.vendor_data?.einvoiceEligibility,
//         invoiceStatus: mapInvoiceStatus(data.data?.invoiceStatus),
//         vendorName: data.data?.vendor_data?.enablement_gov?.tradeName,
//         // pan: data.data?.vendor_data?.pan,
//         pan: data.data?.vendor_data?.vendor_gstin
//           ? data.data.vendor_data.vendor_gstin.substring(2, 12)
//           : "",
//         vendorGSTIN: data.data?.vendor_data?.vendor_gstin,
//         totalGSTAmount: data.data?.Amount_data?.totalGstAmount,
//         // invoiceType:data.data.invType
//         invoiceType: mapInvoiceType(data.data?.Doc_data?.invType),
//         assetLink: data.data?.Doc_data?.assetlink,
//       });

//       const gstinPrefix = data.data.vendor_data.vendor_gstin?.substring(0, 2);
//       const stateShortForm = stateShortFormMapping[gstinPrefix] || "Unknown";
//       setStateShortForm(stateShortForm);

//       if (data) {
//         setIsModalVisible(true);
//         setShowVendorDetails(true);
//       }
//     } catch (error) {
//       console.error("Error validating data:", error);
//       alert("Validation failed. Please try again.");
//     } finally {
//       setIrnLoading(false);
//     }
//   };


//   return (
//     <div>
//       <div className="invoiceContainer">
//         <div className="einvoice-toggle-switch">
//           <div
//             className={`einvoice-toggle-option ${activeTab === "invoice" ? "active" : ""
//               }`}
//             onClick={() => setActiveTab("invoice")}
//           >
//             Invoice #
//           </div>
//           <div
//             className={`einvoice-toggle-option ${activeTab === "irn" ? "active" : ""
//               }`}
//             onClick={() => setActiveTab("irn")}
//           >
//             IRN #
//           </div>
//           <div
//             className={`einvoice-toggle-indicator ${activeTab === "irn" ? "right" : ""
//               }`}
//           />
//         </div>

//         {!showVendorDetails && (
//           <>
//             <h3 className="einvoicecard-title">
//               {activeTab === "invoice" ? "E-invoice Validate" : "IRN Validate"}
//             </h3>

//             {activeTab === "invoice" ? (
//               <>
//                 <div style={{ display: "flex", gap: "16px" }}>
//                   <div className="einvoicecard-form-group">
//                     {irnloading && (
//                       <div
//                         style={{
//                           position: "absolute",
//                           top: 0,
//                           left: 0,
//                           right: 0,
//                           backgroundColor: "transparent",
//                           display: "flex",
//                           justifyContent: "center",
//                           alignItems: "center",
//                           zIndex: 10,
//                         }}
//                       >
//                         <BeatLoader color="#36D7B7" size={20} />
//                       </div>
//                     )}
//                     <div style={{ display: "flex", gap: "16px", width: "100%" }}>
//                       <div className="einvoicecard-input-container"> {/* Vendor Gstin DIV */}
//                         <label >
//                           Vendor GSTIN<span>*</span>
//                         </label>
//                         <input
//                           type="text"
//                           name="vendorGSTIN"
//                           value={formData.vendorGSTIN}
//                           onChange={handleChange}
//                           placeholder="Enter Vendor GSTIN "
//                         />
//                       </div>

//                       <div className="einvoicecard-input-container">
//                         <label>
//                           Financial Year<span>*</span>
//                         </label>
//                         <Select
//                           name="financialYear"
//                           value={formData.financialYear || undefined}
//                           onChange={(value) => handleSelectChange("financialYear", value)}
//                           showArrow={true}
//                           placeholder="Choose financial year"
//                           style={{ width: "100%", color: "black" }}
//                           suffixIcon={<DownOutlined style={{ color: "#0A8394" }} />}
//                           dropdownRender={(menu) => <div style={{ color: "black" }}>{menu}</div>}
//                           className="custom-select"
//                         >
//                           <Option value="2024-25">2024-25</Option>
//                         </Select>
//                       </div>

//                     </div>
//                   </div>

//                   <div
//                     className="einvoicecard-form-group"
//                     style={{ display: "flex" }}
//                   >
//                     <div
//                       style={{ display: "flex", gap: "16px", width: "100%" }}
//                     >
//                       <div className="einvoicecard-input-container">
//                         <label>
//                           Invoice Type<span>*</span>
//                         </label>
//                         <Select
//                           name="invoiceType"
//                           value={formData.invoiceType || undefined} // Controlled component
//                           // onChange={handleChange}
//                           onChange={(value) => handleSelectChange("invoiceType", value)}
//                           showArrow={true}
//                           placeholder="Choose invoice type" // Placeholder when no value is selected
//                           style={{ width: "100%", color: 'black' }} // Adjust width as needed
//                           suffixIcon={<DownOutlined style={{ color: "#0A8394" }} />}
//                           dropdownRender={(menu) => <div style={{ color: "black" }}>{menu}</div>}
//                           className="custom-select"
//                         >
//                           <Option value="tax-invoice" style={{ color: "black" }}>Tax Invoice</Option>
//                           <Option value="debit-note" style={{ color: "black" }}>Debit Note</Option>
//                           <Option value="credit-note" style={{ color: "black" }}>Credit Note</Option>
//                         </Select>
//                       </div>
//                       <div className="einvoicecard-input-container">
//                         <label>
//                           Invoice Number<span>*</span>
//                         </label>
//                         <input
//                           type="text"
//                           name="invoiceNumber"
//                           value={formData.invoiceNumber}
//                           onChange={handleChange}
//                           placeholder="Enter Invoice Number"
//                         />
//                       </div>
//                     </div>
//                   </div>


//                 </div>
//                 <div
//                   style={{ display: "flex", marginTop: "15px", height: "30px" }}
//                 >
//                   <Button
//                     className="restBtn"
//                     onClick={() =>
//                       setFormData({
//                         vendorGSTIN: "",
//                         financialYear: "",
//                         invoiceType: "",
//                         invoiceNumber: "",
//                       })
//                     }
//                   >
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="20"
//                       height="20"
//                       viewBox="0 0 20 20"
//                       fill="none"
//                     >
//                       <path
//                         d="M16.6673 9.16658C16.4635 7.7001 15.7832 6.3413 14.7312 5.2995C13.6792 4.25769 12.3138 3.59068 10.8454 3.40121C9.37697 3.21174 7.887 3.51032 6.60499 4.25096C5.32297 4.99159 4.32003 6.1332 3.75065 7.49992M3.33398 4.16658V7.49992H6.66732M3.33398 10.8333C3.53778 12.2998 4.21809 13.6586 5.27012 14.7004C6.32214 15.7422 7.68752 16.4092 9.15593 16.5987C10.6243 16.7881 12.1143 16.4896 13.3963 15.7489C14.6783 15.0083 15.6813 13.8667 16.2507 12.5M16.6673 15.8333V12.5H13.334"
//                         stroke="#0A8394"
//                         stroke-width="1.5"
//                         stroke-linecap="round"
//                         stroke-linejoin="round"
//                       />
//                     </svg>
//                   </Button>
//                   <Button
//                     className="validateBtn"
//                     onClick={handleValidate}
//                     style={{ width: "25%" }}
//                   >
//                     Validate Now
//                   </Button>
//                 </div>
//               </>
//             ) : (
//               <>
//                 <div className="einvoicecard-form-group">
//                   <div className="einvoicecard-input-container">
//                     <label>
//                       IRN Number<span>*</span>
//                     </label>
//                     {/* <Input
//                       type="text"
//                       placeholder="Enter IRN here"
//                       defaultValue={formData.irnNumber}
//                       onChange={handleChange}
//                     /> */}
//                     <input
//                       type="text"
//                       name="irnNumber"
//                       value={formData.irnNumber}
//                       onChange={handleChange}
//                       style={{ width: "190%" }}
//                       placeholder="Enter IRN here"
//                     />
//                   </div>
//                 </div>
//                 <div className="einvoicecard-button-group" style={{display:'flex'}}>
//                   <Button
//                     className="einvoicecard-cancel"
//                     style={{ color: "#0A8394", borderColor: "#0A8394", height: '40px' }}
//                     onClick={() =>
//                       setFormData({
//                         irnNumber: ""
//                       })
//                     }
//                   >
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="20"
//                       height="20"
//                       viewBox="0 0 20 20"
//                       fill="none"
//                     >
//                       <path
//                         d="M16.6673 9.16658C16.4635 7.7001 15.7832 6.3413 14.7312 5.2995C13.6792 4.25769 12.3138 3.59068 10.8454 3.40121C9.37697 3.21174 7.887 3.51032 6.60499 4.25096C5.32297 4.99159 4.32003 6.1332 3.75065 7.49992M3.33398 4.16658V7.49992H6.66732M3.33398 10.8333C3.53778 12.2998 4.21809 13.6586 5.27012 14.7004C6.32214 15.7422 7.68752 16.4092 9.15593 16.5987C10.6243 16.7881 12.1143 16.4896 13.3963 15.7489C14.6783 15.0083 15.6813 13.8667 16.2507 12.5M16.6673 15.8333V12.5H13.334"
//                         stroke="#0A8394"
//                         stroke-width="1.5"
//                         stroke-linecap="round"
//                         stroke-linejoin="round"
//                       />
//                     </svg>
//                   </Button>
//                   <Button className="validateBtn" onClick={handleValidate}>
//                     Validate Now
//                   </Button>
//                 </div>
//               </>
//             )}
//           </>
//         )}

//         {showVendorDetails && (
//           <div className="vendor-details">
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "flex-start",
//                 paddingTop: 10,
//               }}
//             >
//               <div
//                 className="vendorName"
//                 // style={{ display: "flex", alignItems: "center" }}
//                 style={{
//                   display: "flex", alignItems: "center", maxWidth: "385px", // adjust this value as needed
//                   overflow: "hidden",
//                   whiteSpace: "nowrap",
//                   textOverflow: "ellipsis"
//                 }}              >
//                 <Typography variant="caption" wrapped>
//                   {invoiceData.vendorName}{" "}
//                 </Typography>
//                 {/* <Tag
//                   style={{ marginLeft: 6 }}
//                   icon={<CheckCircleFilled />}
//                   color="green"
//                 >
//                   {invoiceData.eligibleStatus}
//                 </Tag> */}
//                 <Tag
//                   style={{ marginLeft: 6 }}
//                   icon={
//                     invoiceData.eligibleStatus === "Eligible" ? (
//                       <CheckCircleFilled />
//                     ) : (
//                       <CloseCircleFilled />
//                     )
//                   }
//                   color={invoiceData.eligibleStatus === "Eligible" ? "green" : "red"}
//                 >
//                   {invoiceData.eligibleStatus}
//                 </Tag>
//               </div>
//               {/* <p className="vendorName">Vendor_name</p> */}
//               <div className="detailsWrapper" style={{ display: "flex", gap: "15px" }}>
//                 <div
//                   className="panDetails"
//                   style={{ display: "flex", textAlign: "center" }}
//                 >
//                   <Typography variant="xs" color="#3F4047" style={{ marginTop: '1px' }}>
//                     PAN :
//                   </Typography>
//                   <div
//                     className="panValue"
//                     style={{ color: "#0A8394", marginLeft: 4 }}
//                   >
//                     {" "}
//                     {invoiceData.pan}
//                   </div>
//                 </div>
//                 <div className="gstinDetails" style={{ display: "flex", textAlign: "center" }}>
//                   <Typography variant="xs" color="#3F4047" style={{ marginTop: '1px' }}>
//                     GSTIN :
//                   </Typography>
//                   <div className="gstinValue" style={{ display: "flex" }}>
//                     <div
//                       className="stateForm"
//                       style={{
//                         background: "#4169E1",
//                         borderRadius: 3,
//                         marginLeft: 4,
//                         fontSize: 12,
//                         width: 24,
//                         height: 22,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         color: "white",
//                       }}
//                     >
//                       {stateShortForm}
//                     </div>
//                     <div
//                       className="gstin"
//                       style={{ color: "#0A8394", marginLeft: 4 }}
//                     >
//                       {" "}
//                       {invoiceData.vendorGSTIN}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="vendor-table" style={{ display: "flex", gap: 10 }}>
            
//               <div
//                 className="TableView"
//                 style={{
//                   border: "1px solid #E8EAF1",
//                   width: "50%",
//                   gap: 10,
//                   marginTop: 12,
//                   borderRadius: 12,

//                   marginBottom: 16,
//                 }}
//               >
//                 <div
//                   className="row"
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     padding: 8,
//                     boxSizing: "border-box",
//                     borderBottom: "1px solid #E8EAF1",
//                   }}
//                 >
//                   <Typography variant="caption" color="#72747D" style={{ fontSize: '12px', marginTop: '2px' }}>
//                     E-invoice number
//                   </Typography>
//                   <span style={{ display: "flex", alignItems: "center" }}>
//                     <Typography color="#72747D" variant="caption" style={{ fontSize: '12px' }}>
//                       {invoiceData.inum}
//                     </Typography>
//                     <Tag
//                       className="invoiceTypeRow"
//                       style={{
//                         color: "#0A8394",
//                         borderColor: "#03A5B733",
//                         textAlign: "center",
//                         marginLeft: 10,
//                       }}
//                     >
//                       {invoiceData.invoiceType}
//                     </Tag>
//                   </span>
//                 </div>
//                 <div
//                   className="row"
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     padding: 8,
//                     boxSizing: "border-box",
//                     borderBottom: "1px solid #E8EAF1",
//                   }}
//                 >
//                   <Typography variant="caption" color="#72747D" style={{ fontSize: '12px' }}>
//                     Date
//                   </Typography>
//                   <Typography variant="caption" color="#72747D" style={{ fontSize: '12px' }}>
//                     {invoiceData.date}
//                   </Typography>
//                 </div>
//               </div>
//               <div
//                 className="TableView"
//                 style={{
//                   border: "1px solid #E8EAF1",
//                   width: "50%",
//                   gap: 10,
//                   marginTop: 12,
//                   marginBottom: 16,
//                   borderRadius: 12,
//                 }}
//               >
//                 <div className="TableRow">
//                   <div
//                     className="row"
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       padding: 8,
//                       boxSizing: "border-box",
//                       borderBottom: "1px solid #E8EAF1",
              
//                     }}
//                   >
//                     <Typography variant="caption" color="#72747D" style={{ fontSize: '12px', marginTop: '2px' }}>
//                       E-invoice status
//                     </Typography>
//                     {/* <span ><Tag className="eligibleStatusRow">{invoiceData.eligibleStatus}</Tag></span> */}
//                     <Tag
//                       color={invoiceData.invoiceStatus === "Received" ? "green" : "red"}
//                       className={`invoiceStatus ${invoiceData.invoiceStatus === "Received"
//                         ? "received"
//                         : "notReceived"
//                         }`} style={{ display: "flex" }}
//                     >
//                       {/* Conditional SVG Icon */}
//                       {invoiceData.invoiceStatus === "Received" ? (
//                         <svg
//                           width="15"
//                           height="14"
//                           viewBox="0 0 15 14"
//                           fill="none"
//                           xmlns="http://www.w3.org/2000/svg"
//                         >
//                           <path
//                             d="M5.75 7L6.91667 8.16667L9.25 5.83333M2.25 7C2.25 7.68944 2.3858 8.37213 2.64963 9.00909C2.91347 9.64605 3.30018 10.2248 3.78769 10.7123C4.2752 11.1998 4.85395 11.5865 5.49091 11.8504C6.12787 12.1142 6.81056 12.25 7.5 12.25C8.18944 12.25 8.87213 12.1142 9.50909 11.8504C10.146 11.5865 10.7248 11.1998 11.2123 10.7123C11.6998 10.2248 12.0865 9.64605 12.3504 9.00909C12.6142 8.37213 12.75 7.68944 12.75 7C12.75 6.31056 12.6142 5.62787 12.3504 4.99091C12.0865 4.35395 11.6998 3.7752 11.2123 3.28769C10.7248 2.80018 10.146 2.41347 9.50909 2.14963C8.87213 1.8858 8.18944 1.75 7.5 1.75C6.81056 1.75 6.12787 1.8858 5.49091 2.14963C4.85395 2.41347 4.2752 2.80018 3.78769 3.28769C3.30018 3.7752 2.91347 4.35395 2.64963 4.99091C2.3858 5.62787 2.25 6.31056 2.25 7Z"
//                             stroke="#1E7734"
//                             stroke-linecap="round"
//                             stroke-linejoin="round"
//                           />
//                         </svg>
//                       ) : (
//                         <svg
//                           width="15"
//                           height="14"
//                           viewBox="0 0 15 14"
//                           fill="none"
//                           xmlns="http://www.w3.org/2000/svg"
//                         >
//                           <path
//                             d="M11 3.5L4 10.5M4 3.5L11 10.5"
//                             stroke="#C8170D"
//                             stroke-width="1.2"
//                             stroke-linecap="round"
//                             stroke-linejoin="round"
//                           />
//                         </svg>
//                       )}
//                       {invoiceData.invoiceStatus}
//                     </Tag>
//                   </div>
//                   <div
//                     className="row"
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       padding: 8,
//                       boxSizing: "border-box",
//                       borderBottom: "1px solid #E8EAF1",
//                     }}
//                   >
//                     <Typography variant="caption" color="#72747D" style={{ fontSize: '12px' }}>
//                       Amount
//                     </Typography>

//                     <Typography variant="caption" color="#72747D" style={{ fontSize: '12px' }}>
//                       INR {invoiceData.totalGSTAmount}
//                     </Typography>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="vendor-actions" style={{ display: "flex" }}>
//               <Button
//                 className="einvoicecard-reset"
//                 onClick={() => {
//                   setShowVendorDetails(false);
//                   setFormData({
//                     vendorGSTIN: "",
//                     financialYear: "",
//                     invoiceType: "",
//                     invoiceNumber: "",
//                   });
//                 }}
//                 icon={<ArrowIcon style={{ width: "24px", height: "24px" }} />}
//               ></Button>

//               {/* {invoiceData.invoiceStatus === "Received" ? (
//         <button style={{ backgroundColor: "#0A8394", color: 'white', width: '180px' }} className="einvoicecard-view" onClick={() => window.open(invoiceData.assetLink, "_blank")}><EyeOutlined style={{ marginRight: '5px' }} />View</button>
//       ) : invoiceData.invoiceStatus === "Not Received" ? (
//         <Button className="einvoicecard-request" onClick={handleRequestClick} style={{ backgroundColor: "#0A8394", color: 'white', width: '180px' }}>Request</Button>
//       ) : null} */}
//               {(invoiceData.invoiceStatus === "Received" &&
//                 invoiceData.eligibleStatus === "Eligible" &&
//                 invoiceData.assetLink) ||
//                 invoiceData.assetLink ? (
//                 <Button
//                   style={{
//                     backgroundColor: "#0A8394",
//                     color: "white",
//                     width: "180px",
//                     height: '33px',
//                     marginLeft: 8,
//                   }}
//                   className="einvoicecard-view"
//                   onClick={() => window.open(invoiceData.assetLink, "_blank")}
//                 >
//                   <EyeOutlined />
//                   View
//                 </Button>
//               ) : invoiceData.invoiceStatus === "Not Received" &&
//                 invoiceData.eligibleStatus === "Eligible" ? (
//                 <Button
//                   className="einvoicecard-request"
//                   onClick={handleRequestClick}
//                   style={{
//                     backgroundColor: "#0A8394",
//                     color: "white",
//                     width: "180px",
//                   }}
//                 >
//                   Request
//                 </Button>
//               ) : null}

//               {isEmailModalOpen && (
//                 <EmailModal
//                   vendorData={[
//                     {
//                       gstin: invoiceData.vendorGSTIN,
//                       vendorName: invoiceData.vendorName,
//                     },
//                   ]}
//                   isOpen={isEmailModalOpen}
//                   onClose={closeEmailModal}
//                 />
//               )}
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default InvoiceIRN;
//--------------------------------------------------------------------------//



//--------------------------------------------//


import React from "react";
import "./InvoiceIRN.scss";
import { Button, Input, Modal, Tag } from "antd";
import { useState } from "react";
import { useRecoilState } from "recoil";
import {
  gst2ADataState,
  gst2BDataState,
  irndata,
  roleInfo,
  userInfo,
  vendorDetailsDisplay,
  workspaceInfo,
} from "app/config/States/users";

//Import the endpoints
import { API_ENDPOINT_VENDOR_VALIDATE } from "../../vendorfollowup.constants";
import { BeatLoader } from "react-spinners";
import CircleIcon from "@mui/icons-material/Circle";
import { EyeOutlined, CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import { ReactComponent as ArrowIcon } from "../../arrow.svg";
import EmailModal from "../EmailModel/EmailModel";
import Typography from "app/shared/Typography";
import { Select } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { message } from 'antd';
//import InfoOutlineIcon from '@mui/icons-material/InfoOutline';

const InvoiceIRN = () => {
  const [activeTab, setActiveTab] = useState("invoice");
  const { Option } = Select;//new
  const [showVendorDetails, setShowVendorDetails] =
    useRecoilState(vendorDetailsDisplay);
  const [irnloading, setIrnLoading] = useState(false);
  const [is2A, setIs2A] = useState(true);
  const [invoiceData, setInvoiceData] = useRecoilState(irndata);
  const [stateShortForm, setStateShortForm] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const closeEmailModal = () => setIsEmailModalOpen(false);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [irnError, setIrnError] = useState("");//new-----
  const [irnReg, setIrnReg] = useState("");//new-----
  const [formData, setFormData] = useState({
    vendorGSTIN: "",
    financialYear: "",
    invoiceType: "",
    invoiceNumber: "",
    irnNumber: "",
  });
  const handleRequestClick = () => {
    setIsEmailModalOpen(true);
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  // };


  const handleChange = (value, option) => {
    if (option && option.name) {
      // Handling Ant Design Select
      setFormData((prevData) => ({
        ...prevData,
        [option.name]: value, // Update based on the select field name
      }));
    } else if (value?.target) {
      // Handling regular input field
      const { name, value: inputValue } = value.target;
      setFormData((prevData) => ({
        ...prevData,
        [name]: inputValue,
      }));
    }
  };

  const handleSelectChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };




  const stateShortFormMapping = {
    "01": "JK", // Jammu & Kashmir
    "02": "HP", // Himachal Pradesh
    "03": "PB", // Punjab
    "04": "CH", // Chandigarh
    "05": "UK", // Uttarakhand
    "06": "HR", // Haryana
    "07": "DL", // Delhi
    "08": "RJ", // Rajasthan
    "09": "UP", // Uttar Pradesh
    10: "BR", // Bihar
    11: "SK", // Sikkim
    12: "AR", // Arunachal Pradesh
    13: "NL", // Nagaland
    14: "MN", // Manipur
    15: "MZ", // Mizoram
    16: "TR", // Tripura
    17: "ML", // Meghalaya
    18: "AS", // Assam
    19: "WB", // West Bengal
    20: "JH", // Jharkhand
    21: "OD", // Odisha
    22: "CG", // Chhattisgarh
    23: "MP", // Madhya Pradesh
    24: "GJ", // Gujarat
    25: "DD", // Daman & Diu
    26: "DN", // Dadra & Nagar Haveli
    27: "MH", // Maharashtra
    28: "AP", // Andhra Pradesh
    29: "KA", // Karnataka
    30: "GA", // Goa
    31: "LD", // Lakshadweep
    32: "KL", // Kerala
    33: "TN", // Tamil Nadu
    34: "PY", // Puducherry
    35: "AN", // Andaman & Nicobar Islands
    36: "TG", // Telangana
    37: "AP", // Andhra Pradesh (New)
  };
  const mapInvoiceStatus = (status) => {
    return status === "Invoice Received" ? "Received" : "Not Received";
  };

  const mapInvoiceType = (type) => {
    switch (type) {
      case "INV":
        return "E-tax invoice";
      case "CRN":
        return "Credit note";
      case "DBN":
        return "Debit note";
      default:
        return type; // Return the original type if no mapping is found
    }
  };



  const handleValidate = async () => {
    setIrnError(""); // Clear any previous error messages
    setIrnReg("")
  
    // Check if required fields are filled out
    if (
      (activeTab === "invoice" &&
        (!formData.vendorGSTIN ||
          !formData.financialYear ||
          !formData.invoiceType ||
          !formData.invoiceNumber)) ||
      (activeTab === "irn" && !formData.irnNumber)
    ) {
      alert("Please fill all the required fields.");
      return;
    }
  
    // Validate IRN format
    if (
      activeTab === "irn" &&
      (!formData.irnNumber || formData.irnNumber.length !== 64)
    ) {
      const errorMsg =
        "Invalid IRN format (Note: IRN must be 64-character alphanumeric without any spaces or special characters)";
      setIrnError(errorMsg); // Set error to display below input
      return;
    }
  
    setIrnLoading(true); // Start loading state
  
    try {
      const currentWorkspace = localStorage.getItem("currentWorkspace");
      const collection = "vendor_tally";
  
      // Build the payload for the API request
      const payload =
        activeTab === "irn"
          ? {
              irnNumber: formData.irnNumber,
              collection: collection,
              db: "gstservice",
              currentWorkspace,
            }
          : {
              ...formData,
              collection: collection,
              db: "gstservice",
              currentWorkspace,
            };
  
      const response = await fetch("https://fuzzyapi.finkraftai.com/validate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
  
      const data = await response.json();
  
      // Check if the response indicates an error (status_cd === "0")
      if (data?.status_cd === "0") {
        // Set the error message if status_cd is 0
        const errorMsg = data?.message || "An unknown error occurred.";
        setIrnError(errorMsg); // Set error to display below input
        setIsModalVisible(true); // Show the modal for error details
        return;
      }
  
      // Update the invoice data based on the successful response
      setInvoiceData({
        regirp: data.web_data.regirp,
        regtime: data.web_data.regtime,
        status: data.web_data.status,
        irn: data.web_data.irn,
        inum: data.data?.Doc_data?.inum,
        date: data.data?.Doc_data?.dt,
        eligibleStatus: data.data?.vendor_data?.einvoiceEligibility,
        invoiceStatus: mapInvoiceStatus(data.data?.invoiceStatus),
        vendorName: data.data?.vendor_data?.enablement_gov?.tradeName,
        pan: data.data?.vendor_data?.vendor_gstin
          ? data.data.vendor_data.vendor_gstin.substring(2, 12)
          : "",
        vendorGSTIN: data.data?.vendor_data?.vendor_gstin,
        totalGSTAmount: data.data?.Amount_data?.totalGstAmount,
        invoiceType: mapInvoiceType(data.data?.Doc_data?.invType),
        assetLink: data.data?.Doc_data?.assetlink,
      });
  
      // Show the modal with vendor details
      setIsModalVisible(true);
      setShowVendorDetails(true);
    } catch (error) {
      console.error("Error validating data:", error);
      const errorMsg = "Failed to validate IRN. Please try again.";
      setIrnError(errorMsg); // Show error in UI if API fails
      setIsModalVisible(true); // Show the modal for the error state
    } finally {
      setIrnLoading(false); // Reset the loading state
    }
  };
  const resetFormData = (tab) => {
  if (tab === "invoice") {
    setFormData({
      vendorGSTIN: "",
      financialYear: "",
      invoiceType: "",
      invoiceNumber: "",
      irnNumber: "",
    });
  } else if (tab === "irn") {
    setFormData({
      irnNumber: "",
      vendorGSTIN: "",
      financialYear: "",
      invoiceType: "",
      invoiceNumber: "",
    });
  }
  setInvoiceData({});
  setIrnError("");
  setIrnReg("");
  setShowVendorDetails(false);
};
  
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div>
      <div className="invoiceContainer">

        <div className="einvoice-toggle-switch">
          <div
            className={`einvoice-toggle-option ${activeTab === "invoice" ? "active" : ""
              }`}
            onClick={() => {setActiveTab("invoice")
             resetFormData("invoice");

            }}
            

          >
            Invoice #
          </div>
          <div
            className={`einvoice-toggle-option ${activeTab === "irn" ? "active" : ""
              }`}
            onClick={() => {setActiveTab("irn")
             resetFormData("irn");  
            }}
          >
            IRN #
          </div>
          <div
            className={`einvoice-toggle-indicator ${activeTab === "irn" ? "right" : ""
              }`}
          />
        </div>

        {!showVendorDetails && (
          <>
            <h3 className="einvoicecard-title">
              {activeTab === "invoice" ? "E-invoice Validate" : "IRN Validate"}
            </h3>

            {activeTab === "invoice" ? (
              <>
                <div style={{ display: "flex", gap: "16px" }}>
                  <div className="einvoicecard-form-group">
                    {irnloading && (
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          backgroundColor: "transparent",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          zIndex: 10,
                        }}
                      >
                        <BeatLoader color="#36D7B7" size={20} />
                      </div>
                    )}
                    <div style={{ display: "flex", gap: "16px", width: "100%" }}>
                      <div className="einvoicecard-input-container"> {/* Vendor Gstin DIV */}
                        <label >
                          Vendor GSTIN<span>*</span>
                        </label>
                        <input
                          type="text"
                          name="vendorGSTIN"
                          value={formData.vendorGSTIN}
                          onChange={handleChange}
                          placeholder="Enter Vendor GSTIN "
                        />
                      </div>

                      <div className="einvoicecard-input-container">
                        <label>
                          Financial Year<span>*</span>
                        </label>
                        <Select
                          name="financialYear"
                          value={formData.financialYear || undefined}
                          onChange={(value) => handleSelectChange("financialYear", value)}
                          showArrow={true}
                          placeholder="Choose financial year"
                          style={{ width: "100%", color: "black" }}
                          suffixIcon={<DownOutlined style={{ color: "#0A8394" }} />}
                          dropdownRender={(menu) => <div style={{ color: "black" }}>{menu}</div>}
                          className="custom-select"
                        >
                          <Option value="2024-25">2024-25</Option>
                          <Option value="2025-26">2025-26</Option>
                        </Select>
                      </div>

                    </div>
                  </div>

                  <div
                    className="einvoicecard-form-group"
                    style={{ display: "flex" }}
                  >
                    <div
                      style={{ display: "flex", gap: "16px", width: "100%" }}
                    >
                      <div className="einvoicecard-input-container">
                        <label>
                          Invoice Type<span>*</span>
                        </label>
                        <Select
                          name="invoiceType"
                          value={formData.invoiceType || undefined} // Controlled component
                          // onChange={handleChange}
                          onChange={(value) => handleSelectChange("invoiceType", value)}
                          showArrow={true}
                          placeholder="Choose invoice type" // Placeholder when no value is selected
                          style={{ width: "100%", color: 'black' }} // Adjust width as needed
                          suffixIcon={<DownOutlined style={{ color: "#0A8394" }} />}
                          dropdownRender={(menu) => <div style={{ color: "black" }}>{menu}</div>}
                          className="custom-select"
                        >
                          <Option value="tax-invoice" style={{ color: "black" }}>Tax Invoice</Option>
                          <Option value="debit-note" style={{ color: "black" }}>Debit Note</Option>
                          <Option value="credit-note" style={{ color: "black" }}>Credit Note</Option>
                        </Select>
                      </div>
                      <div className="einvoicecard-input-container">
                        <label>
                          Invoice Number<span>*</span>
                        </label>
                        <input
                          type="text"
                          name="invoiceNumber"
                          value={formData.invoiceNumber}
                          onChange={handleChange}
                          placeholder="Enter Invoice Number"
                        />
                     
                       
                       
                
                       
                      </div>
                     
                    
                    </div>
                 
                  
                  </div>
                 
                 


                </div>
                <div>
                  {irnError && (
                      <div style={{ color: "red", fontSize: '12px',width: "100%" }}>{irnError}</div>
                    )}
                    {irnReg && (
                      <div style={{ color: "red", fontSize: '12px',width: "100%" }}>{irnReg}</div>
                    )}
                    </div>
                <div
                  style={{ display: "flex", marginTop: "15px", height: "30px" }}
                >
                  <Button
                    className="restBtn"
                    onClick={() =>
                      setFormData({
                        vendorGSTIN: "",
                        financialYear: "",
                        invoiceType: "",
                        invoiceNumber: "",
                      })
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M16.6673 9.16658C16.4635 7.7001 15.7832 6.3413 14.7312 5.2995C13.6792 4.25769 12.3138 3.59068 10.8454 3.40121C9.37697 3.21174 7.887 3.51032 6.60499 4.25096C5.32297 4.99159 4.32003 6.1332 3.75065 7.49992M3.33398 4.16658V7.49992H6.66732M3.33398 10.8333C3.53778 12.2998 4.21809 13.6586 5.27012 14.7004C6.32214 15.7422 7.68752 16.4092 9.15593 16.5987C10.6243 16.7881 12.1143 16.4896 13.3963 15.7489C14.6783 15.0083 15.6813 13.8667 16.2507 12.5M16.6673 15.8333V12.5H13.334"
                        stroke="#0A8394"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </Button>
                  <Button
                    className="validateBtn"
                    onClick={handleValidate}
                    style={{ width: "25%" }}
                  >
                    Validate Now
                  </Button>
                </div>
              </>
            ) : (
              <>
                <div className="einvoicecard-form-group">
                  <div className="einvoicecard-input-container">
                    <label>
                      IRN Number<span>*</span>
                    </label>
                    {/* <Input
                      type="text"
                      placeholder="Enter IRN here"
                      defaultValue={formData.irnNumber}
                      onChange={handleChange}
                    /> */}
                    <input
                      type="text"
                      name="irnNumber"
                      value={formData.irnNumber}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                      placeholder="Enter IRN here"
                    />
                    {irnError && (
                      <div style={{ color: "red", fontSize: '12px' }}>{irnError}</div>
                    )}
                    {irnReg && (
                      <div style={{ color: "red", fontSize: '12px' }}>{irnReg}</div>
                    )}
                  </div>
                </div>
                <div className="einvoicecard-button-group" style={{ display: 'flex' }}>
                  <Button
                    className="einvoicecard-cancel"
                    style={{ color: "#0A8394", borderColor: "#0A8394", height: '40px' }}
                    onClick={() => {
                      setFormData({
                        irnNumber: "",
                      });
                      setIrnError("");
                      setIrnReg("");
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M16.6673 9.16658C16.4635 7.7001 15.7832 6.3413 14.7312 5.2995C13.6792 4.25769 12.3138 3.59068 10.8454 3.40121C9.37697 3.21174 7.887 3.51032 6.60499 4.25096C5.32297 4.99159 4.32003 6.1332 3.75065 7.49992M3.33398 4.16658V7.49992H6.66732M3.33398 10.8333C3.53778 12.2998 4.21809 13.6586 5.27012 14.7004C6.32214 15.7422 7.68752 16.4092 9.15593 16.5987C10.6243 16.7881 12.1143 16.4896 13.3963 15.7489C14.6783 15.0083 15.6813 13.8667 16.2507 12.5M16.6673 15.8333V12.5H13.334"
                        stroke="#0A8394"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </Button>
                  <Button className="validateBtn" onClick={handleValidate}>
                    Validate Now
                  </Button>
                </div>
              </>
            )}
          </>
        )}

        {showVendorDetails && (
          <div className="vendor-details">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                paddingTop: 10,
              }}
            >
              <div
                className="vendorName"
              >
                <Typography variant="caption" style={{ color: '#777', marginBottom: '15px' }} >
                  IRN Number
                </Typography>
                {/* <span style={{ border: '1px solid #DDD', borderRadius: '8px', padding: '6px 60px 6px 10px', width: "190%" }}>
                  {invoiceData.irn}{" "}
                </span> */}
                <input
                  type="text"
                  value={invoiceData.irn || ""}
                  readOnly
                  style={{
                    border: '1px solid #DDD',
                    borderRadius: '8px',
                    padding: '6px 100px 6px 10px',
                    width: '200%',
                  }}
                />
              </div>
              {/* <p className="vendorName">Vendor_name</p> */}
            </div>
            {/* ///----------new changes */}
            <div style={{ marginTop: '16px', display: 'flex', gap: '15px' }}>

              <div style={{ borderRadius: '4px', border: '1px solid #EEE', padding: '5px 4px', display: 'flex', width: '145px', gap: '24px', height: '30px', alignItems: 'center' }}>
                <Typography variant="caption" style={{ color: '#555', fontSize: '14px' }}>
                  IRP Name
                </Typography>
                <span style={{ color: '#72747D', fontSize: '12px' }}
                >
                  {invoiceData.regirp}
                </span>
              </div>

              <div style={{ borderRadius: '4px', border: '1px solid #EEE', padding: '5px 4px', display: 'flex', width: '155px', gap: '24px', height: '30px', alignItems: 'center' }}>
                <Typography variant="caption" style={{ color: '#555', fontSize: '14px' }}>
                  Status
                </Typography>
                <Typography variant="caption" color="#72747D" style={{ fontSize: '12px', display: 'flex', marginTop: '4px' }}>
                  <span className="dot green" style={{ marginTop: '4px' }}></span> {invoiceData.status === "ACT" ? "REGISTERED" : invoiceData.status}
                </Typography>
              </div>

              <div style={{ borderRadius: '4px', border: '1px solid #EEE', padding: '5px 4px', display: 'flex', width: '350px', gap: '10px', height: '30px', alignItems: 'center' }}>
                <Typography variant="caption" style={{ color: '#555', fontSize: '14px' }}>
                  Date & Time of Registration
                </Typography>
                <Typography variant="caption" color="#72747D" style={{ fontSize: '12px' }}>
                  {invoiceData.regtime}
                </Typography>
              </div>
              <div style={{ position: "relative", display: "inline-block", marginTop: "10px" }}>
                {/* Info Icon */}
                <div
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                  style={{ display: "inline-block", cursor: "pointer" }}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g id="material-symbols:info-outline">
                      <path
                        id="Vector"
                        d="M11 17H13V11H11V17ZM12 9C12.2833 9 12.521 8.904 12.713 8.712C12.905 8.52 13.0007 8.28267 13 8C12.9993 7.71733 12.9033 7.48 12.712 7.288C12.5207 7.096 12.2833 7 12 7C11.7167 7 11.4793 7.096 11.288 7.288C11.0967 7.48 11.0007 7.71733 11 8C10.9993 8.28267 11.0953 8.52033 11.288 8.713C11.4807 8.90567 11.718 9.00133 12 9ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88334 20.6867 5.825 19.9743 4.925 19.075C4.025 18.1757 3.31267 17.1173 2.788 15.9C2.26333 14.6827 2.00067 13.3827 2 12C1.99933 10.6173 2.262 9.31733 2.788 8.1C3.314 6.88267 4.02633 5.82433 4.925 4.925C5.82367 4.02567 6.882 3.31333 8.1 2.788C9.318 2.26267 10.618 2 12 2C13.382 2 14.682 2.26267 15.9 2.788C17.118 3.31333 18.1763 4.02567 19.075 4.925C19.9737 5.82433 20.6863 6.88267 21.213 8.1C21.7397 9.31733 22.002 10.6173 22 12C21.998 13.3827 21.7353 14.6827 21.212 15.9C20.6887 17.1173 19.9763 18.1757 19.075 19.075C18.1737 19.9743 17.1153 20.687 15.9 21.213C14.6847 21.739 13.3847 22.0013 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
                        fill="#999999"
                      />
                    </g>
                  </svg>
                </div>

                {/* Tooltip */}
                {showTooltip && (
                  <div
                    style={{
                      position: "absolute",
                      top: "30px",
                      left: "0",
                      backgroundColor: "#fff",
                      color: "#72747D",
                      fontSize: "12px",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      padding: "8px",
                      width: "250px",
                      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                      zIndex: 10,
                    }}
                  >
                    Note: As e-Invoicing has started from 1-10-2020, the documents with date from FY 2020-21 onwards are only made available here.
                  </div>
                )}
              </div>

            </div>

            {/* ----- */}

            <div className="vendor-actions" style={{ display: "flex", justifyContent: 'space-between', marginTop: '5px' }}>
              <Button
                className="einvoicecard-reset"
                onClick={() => {
                  setShowVendorDetails(false);
                  setFormData({
                    vendorGSTIN: "",
                    financialYear: "",
                    invoiceType: "",
                    invoiceNumber: "",
                  });
                }}
                icon={<ArrowIcon style={{ width: "24px", height: "24px" }} />}
              ></Button>
              {/* <Button type="default" color="#0a8394">Bulk verification</Button> */}
              {/* {invoiceData.invoiceStatus === "Received" ? (
        <button style={{ backgroundColor: "#0A8394", color: 'white', width: '180px' }} className="einvoicecard-view" onClick={() => window.open(invoiceData.assetLink, "_blank")}><EyeOutlined style={{ marginRight: '5px' }} />View</button>
      ) : invoiceData.invoiceStatus === "Not Received" ? (
        <Button className="einvoicecard-request" onClick={handleRequestClick} style={{ backgroundColor: "#0A8394", color: 'white', width: '180px' }}>Request</Button>
      ) : null} */}
              {(invoiceData.invoiceStatus === "Received" &&
                invoiceData.eligibleStatus === "Eligible" &&
                invoiceData.assetLink) ||
                invoiceData.assetLink ? (
                <Button
                  style={{
                    backgroundColor: "#0A8394",
                    color: "white",
                    width: "180px",
                    height: '33px',
                    marginLeft: 8,
                  }}
                  className="einvoicecard-view"
                  onClick={() => window.open(invoiceData.assetLink, "_blank")}
                >
                  <EyeOutlined />
                  View
                </Button>
              ) : invoiceData.invoiceStatus === "Not Received" &&
                invoiceData.eligibleStatus === "Eligible" ? (
                <Button
                  className="einvoicecard-request"
                  onClick={handleRequestClick}
                  style={{
                    backgroundColor: "#0A8394",
                    color: "white",
                    width: "180px",
                  }}
                >
                  Request
                </Button>
              ) : null}

              {isEmailModalOpen && (
                <EmailModal
                  vendorData={[
                    {
                      gstin: invoiceData.vendorGSTIN,
                      vendorName: invoiceData.vendorName,
                    },
                  ]}
                  isOpen={isEmailModalOpen}
                  onClose={closeEmailModal}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InvoiceIRN;

